"use strict";
/*!
 * Copyright 2012 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntSize = void 0;
/**
 * Represents whether a given Ion int value will fit safely within a Number or if it requires a BigInt.
 */
var IntSize;
(function (IntSize) {
    /** The Ion int value fits safely in a number. */
    IntSize[IntSize["Number"] = 0] = "Number";
    /** The Ion int value requies a BigInt. */
    IntSize[IntSize["BigInt"] = 1] = "BigInt";
})(IntSize = exports.IntSize || (exports.IntSize = {}));
exports.default = IntSize;
